import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import BaseAnticipation from "../../../vendor_core/core/src/views/BaseAnticipation";
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import SpineAnimation from "../../../vendor_core/core/src/views/SpineAnimation";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import App from "../../../vendor_core/core/src/App";
import GameSoundVars from "../enums/GameSoundVars";


export default class TRWAnticipation extends BaseAnticipation {
    private anticipationSound: Howl;
    private anim: SpineAnimation;

    public play(reelId: number): void {
        const anticipation = ViewManager.getLayer(DefaultLayers.Anticipation).setScene("anticipation");
        this.anim = anticipation.spineAnimations.get("anticipation");
        this.anim.play("animation");

        this.anticipationSound = SoundController.playSound( SoundVars.EFFECT_REEL_ANTICIPATION, false );
    }

    public stop(reelsSpinning: number, reelId?: number): void {
        if (!reelsSpinning) {
            if (this.anticipationSound) {
                SoundController.stopSound(this.anticipationSound);
                this.anticipationSound = null;
                if (!SpinModel.hasFreespinsWon() && !this.hasScatter(reelId)) {
                    SoundController.playSound(GameSoundVars.REEL_ANTICIPATION_NO_WIN);
                }
            }

            ViewManager.getLayer(DefaultLayers.Anticipation).clear();
        }
    }

    private hasScatter(reelId: number): boolean {
        const reels = Array.from(Array(ReelGroup.instance.reels.length).keys());
        const stopData = SpinModel.getStopSymbolsForReels(reels);
        return this.hasScatterOnSpinner(stopData, reelId);
    }

    private hasScatterOnSpinner(stopData: any[][], reelIdx: number): boolean {
        let hasScatter = false;

        for (
            let rowIdx = GameModel.gameConfig.reelExtraSymbols;
            rowIdx < GameModel.gameConfig.reelExtraSymbols + 3;
            rowIdx++
        ) {
            const fallId = stopData[reelIdx][rowIdx];
            if (fallId == App.config.scatterSymId) {
                hasScatter = true;
                break;
            }
        }

        return hasScatter;
    }
}